var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{style:({ height: '92vh' }),attrs:{"light":"","hide-delimiters":"","interval":"100000"}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i},[_c(item.src,{tag:"component"})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47db3f29","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/carousel.vue
// module id = 308
// module chunks = 1